import moment from 'moment-timezone';
import { dateTimeFromDateObjectOrString, relativeDateIsValid } from '../../helpers/dateUtility';

angular.module('ResearchKitApplicationModule').factory('predicateEvaluator', [function () {
	var predicateEvaluators = [];
	predicateEvaluators["TruePredicate"] = function (predicate, managedResults) {
		return true;
	}
	predicateEvaluators["FalsePredicate"] = function (predicate, managedResults) {
		return false;
	}


	predicateEvaluators["BooleanQuestionResultPredicate"] = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		var answer = questionResult ? questionResult.Answers[0] : undefined;
		if (!questionResult || questionResult.Type != 'QuestionResult' || answer === undefined || answer === null || answer === '') { return false; }
		return predicate.expectedAnswer === (answer === 'true' || answer === 'True' || answer === true);
	}
	predicateEvaluators["ConsentPredicate"] = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'ConsentSignatureResult') { return false; }
		return predicate.didConsent === questionResult.Consented;
	}

	predicateEvaluators["WebViewResultPredicate"] = function (predicate, managedResults) {
		if (predicate.hasOwnProperty('expectedString') === predicate.hasOwnProperty('matchingPattern')) return false;

		var webViewResult = getResult(predicate, managedResults);
		if (!webViewResult || webViewResult.Type != 'WebViewStepResult') { return false; }

		if (predicate.hasOwnProperty('expectedString')) {
			return webViewResult.Result === predicate.expectedString;
		} else if (predicate.hasOwnProperty('matchingPattern')) {
			var regex = new RegExp(predicate.matchingPattern);
			return regex.test(webViewResult.Result);
		}
	};

	var numericPredicateEvaluator = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'QuestionResult') { return false; }
		var answer = questionResult.Answers[0];

		var result = true;
		if (!_.isUndefined(predicate.expectedAnswer) && (_.isUndefined(answer) || predicate.expectedAnswer != answer)) {
			result = false;
		}
		if (!_.isUndefined(predicate.maximumExpectedAnswerValue) && (_.isUndefined(answer) || predicate.maximumExpectedAnswerValue < answer)) {
			result = false;
		}
		if (!_.isUndefined(predicate.minimumExpectedAnswerValue) && (_.isUndefined(answer) || predicate.minimumExpectedAnswerValue > answer)) {
			result = false;
		}
		return result;
	}
	predicateEvaluators["NumericQuestionResultPredicate"] = numericPredicateEvaluator;
	predicateEvaluators["ScaleQuestionResultPredicate"] = numericPredicateEvaluator;
	predicateEvaluators["TextQuestionResultPredicate"] = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'QuestionResult') { return false; }
		return questionResult.Answers[0] === predicate.expectedString;
	}
	predicateEvaluators["ChoiceQuestionResultPredicate"] = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'QuestionResult') { return false; }
		var result = false;
		if (!_.isUndefined(predicate.expectedString)) {
			result = questionResult.Answers.indexOf(predicate.expectedString) != -1;
		}
		if (!_.isUndefined(predicate.expectedStrings)) {
			result = _.every(predicate.expectedStrings, function (expectedString) { return questionResult.Answers.indexOf(expectedString) != -1 });
		}
		return result;
	}

	var datePredicateEvaluator = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'QuestionResult') { return false; }
		var answer = questionResult.Answers[0];
		if (_.isUndefined(answer)) { return false; }
		var result = true;
		if (!_.isUndefined(predicate.maximumExpectedDate)) {
			var maximumExpectedDate = dateTimeFromDateObjectOrString(predicate.maximumExpectedDate);
			if (maximumExpectedDate && moment(answer).isAfter(maximumExpectedDate)) {
				result = false;
			}
		}
		if (!_.isUndefined(predicate.minimumExpectedDate)) {
			var minimumExpectedDate = dateTimeFromDateObjectOrString(predicate.minimumExpectedDate);
			if (minimumExpectedDate && moment(minimumExpectedDate).isAfter(moment(answer))) {
				result = false;
			}
		}
		return result;
	};
	var timePredicateEvaluator = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);
		if (!questionResult || questionResult.Type != 'QuestionResult') { return false; }
		var answer = questionResult.Answers[0];
		if (_.isUndefined(answer)) { return false; }
		var result = true;
		if (!_.isUndefined(predicate.maximumExpectedDate)) {
			if (relativeDateIsValid(predicate.maximumExpectedDate)) {
				var maximumRelativeDate = dateTimeFromDateObjectOrString(predicate.maximumExpectedDate);
				if (maximumRelativeDate && moment(answer, "H:mm A").isAfter(moment(moment(maximumRelativeDate).format("H:mm A"), "H:mm A"))) {
					result = false;
				}
			} else if (moment(answer, "H:mm A").isAfter(moment(predicate.maximumExpectedDate.split("T")[1], "HH:mm:ss"))) {
				result = false;
			}
		}
		if (!_.isUndefined(predicate.minimumExpectedDate)) {
			if (relativeDateIsValid(predicate.minimumExpectedDate)) {
				var minimumRelativeDate = dateTimeFromDateObjectOrString(predicate.minimumExpectedDate);
				if (minimumRelativeDate && moment(moment(minimumRelativeDate).format("H:mm A"), "H:mm A").isAfter(moment(answer, "H:mm A"))) {
					result = false;
				}
			} else if (moment(predicate.minimumExpectedDate.split("T")[1], "HH:mm:ss").isAfter(moment(answer, "H:mm A"))) {
				result = false;
			}
		}
		return result;
	};
	predicateEvaluators["DateQuestionResultPredicate"] = datePredicateEvaluator;
	predicateEvaluators["TimeOfDayQuestionResultPredicate"] = timePredicateEvaluator;
	predicateEvaluators["HeightWeightQuestionResultPredicate"] = numericPredicateEvaluator;

	predicateEvaluators["NilQuestionResultPredicate"] = function (predicate, managedResults) {
		var questionResult = getResult(predicate, managedResults);

		// if question is skipped there will be no questionResult
		if (!questionResult) {
			return true;
		}

		// ResearchKit Documentation:
		// A question result has a `nil` answer if it was generated by a step that was skipped by
		// the user or if it was part of a form step and the question was left unanswered.

		// This checks for an actual answer (both question and form steps)
		if (questionResult.hasOwnProperty("Answers")) {
			return questionResult.Answers === null || questionResult.Answers.length === 0 || _.every(questionResult.Answers, function (answer) { return _.isUndefined(answer) || answer === "" || answer === null; });
		} else if (questionResult.hasOwnProperty("File")) {
			if (_.isUndefined(questionResult.File) || questionResult.File === "" || questionResult.File === null) {
				return true;
			}
			return false;
		}
		return true;
	}
	predicateEvaluators["NotCompoundPredicate"] = function (predicate, managedResults) {
		return !evaluatePredicate(predicate.subpredicate, managedResults);
	}
	predicateEvaluators["OrCompoundPredicate"] = function (predicate, managedResults) {
		return _.some(predicate.subpredicates, function (sub) { return evaluatePredicate(sub, managedResults); });
	}
	predicateEvaluators["AndCompoundPredicate"] = function (predicate, managedResults) {
		return _.every(predicate.subpredicates, function (sub) { return evaluatePredicate(sub, managedResults); });
	}

	function evaluatePredicate(predicate, managedResults) {
		var evaluator = predicateEvaluators[predicate.type];
		if (!evaluator) {
			throw "Unsupported Predicate type: " + predicate.type;
		}
		var result = evaluator(predicate, managedResults);
		return result;
	}

	function getResult(predicate, managedResults) {
		var stepIdentifier = predicate.stepIdentifier != null ? predicate.stepIdentifier : predicate.resultIdentifier;
		var stepResult = managedResults[stepIdentifier];

		if (!stepResult) { return null; }
		for (var i = 0; i < stepResult.QuestionResults.length; i++) {
			if (stepResult.QuestionResults[i].Identifier == predicate.resultIdentifier) {
				return stepResult.QuestionResults[i];
			}
		}
		return null;
	}

	predicateEvaluators["ExpressionPredicate"] = function(predicate, managedResults) {
		// We want Expressions to resolve to a boolean value.  The back end returns
		// a capitalized "True" or "False"
		return predicate.expression === "True";
	}

	//only used in MyDataHelps Designer "try it out" mode
	const falsePredicate = () => false;
	predicateEvaluators["CustomFieldPredicate"] = falsePredicate;
	predicateEvaluators["DemographicFieldPredicate"] = falsePredicate;
	predicateEvaluators["InstitutionPredicate"] = falsePredicate;

	return {
		evaluatePredicate: evaluatePredicate
	};
}]);